import React from 'react';
import { ProductSimilarPriceAttributesInterface } from 'modules/product/interfaces/product-similar-price-attributes.interface';

import './product-comparison-desktop-attributes.scss';

interface ProductComparisonAttributesProps {
    attributes: ProductSimilarPriceAttributesInterface[];
}

const ProductComparisonDesktopAttributes: React.FC<ProductComparisonAttributesProps> = ({ attributes }) => {
    const maxRowNumber = 7;

    return (
        <div className="comparison-attributes-d">
            <div className="comparison-attributes-d__row">
                <div className="comparison-attributes-d__row__cell label">
                    Szczegółowe dane
                </div>
                <div className="comparison-attributes-d__row__cell" />
                <div className="comparison-attributes-d__row__cell" />
                <div className="comparison-attributes-d__row__cell" />
            </div>
            {attributes.slice(0, maxRowNumber).map(rows => (
                <div className="comparison-attributes-d__row" key={rows.row.label}>
                    <div className="comparison-attributes-d__row__cell">
                        {rows.row.label}
                    </div>
                    <div className="comparison-attributes-d__row__cell">
                        {rows.row.currentProductValue || '-'}
                    </div>
                    <div className="comparison-attributes-d__row__cell">
                        {rows.row.expensiveProductValue || '-'}
                    </div>
                    <div className="comparison-attributes-d__row__cell">
                        {rows.row.cheaperProductValue || '-'}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProductComparisonDesktopAttributes;
